import PadraoModel from 'src/core/model/PadraoModel.js'

export default class UsadosbrAcessorioModel extends PadraoModel {
  recurso = 'usadosbr/acessorios';
  microServico = 'automotor';
  include = null;
  searchFixo = null;
  nome = 'Acessórios Usadosbr';

  colunasGrid = [
  ];

  form = {
    id: null,
    nome: null
  };

  constructor () {
    super()
    this.formLimpo = Object.assign({}, this.form)
  }
}
